export default class ThemeState
{
    theme: string = "plain";
    themeRef: any = null; 
}


// WEBPACK FOOTER //
// ./src/deckard/models/state/ThemeState.ts